// @flow
/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './styles/main.scss';

if (process.env.NODE_ENV === 'production') {
  require('./scripts/index.prod');
} else {
  require('./scripts/index.dev');
}
